import { dateToString } from '../../../redux/middlewares/app/fill/formatDataForApi';

const formatDataBeforeStringify = (data) => {
    dateToString(data);

    return data;
};

export default formatDataBeforeStringify;
